import { ChiptaElement, html, unsafeHTML } from 'chipta-libs/main.js';
import 'chipta-libs/components/ticketshop-shell.js';
import 'chipta-libs/components/ticketshop-header.js';
import { layoutStyles } from 'chipta-libs/styles/layout.js';

class ErrorPage extends layoutStyles(ChiptaElement) {

  render() {

    return html`

      <ticketshop-shell>
        <ticketshop-header headertext=${_header_text}>
          <div class="content">
            ${unsafeHTML(_error_text)}
          </div>
        </ticketshop-header>
      </ticketshop-shell>

      <style>

        :host {
          display: flex;
          min-height: 100%;
        }

        .order-table {
          width: 100%;
        }

      </style>

    `;

  }

}

customElements.define('error-page', ErrorPage);
